module.exports = __webpack_public_path__ + "static/Img_pledge_graph_01@2x-4c8cf159b3a2c8f4ece3cc83409c38c2.png";